import { h, Component } from 'preact';
import s from 'components/shared/articleThumb/articleThumb.sss';
import { Link } from 'components/core/link/link.js';
import HTML from 'components/core/html/html.js';

export default class ArticleThumb extends Component {

	constructor(props) {
		super(props);
		this.state = { fullBody: false };
		this.toggleFullBody = this.toggleFullBody.bind(this);
		// Why are we doing this ? It's not used everywhere either, sometimes we just use s
		this.s = s;
	}

	toggleFullBody(event) {
		event.preventDefault();
		this.setState({ fullBody: !this.state.fullBody });
	}

	getExtraContent() { }

	getExtraContentBottom() { }

	renderBodyImage() {
		let data = this.props.data;
		let img = <img class={this.s.bodyImage} src={data.imageSrc} alt={data.imageAlt} />;
		if (data.imageLink) {
			img = (
				<Link class={this.s.imageLink} href={data.imageLink} target="_blank">
					<img class={this.s.bodyImage} src={data.imageSrc} alt={data.imageAlt} />
				</Link>
			);
		}
		return img;
	}

	render(props) {
		const {
			data,
			copy,
			thumbClass
		} = props;

		if (!data) return;
		let readMore = '';
		let body = copy[data.body] || data.body || '';
		// let img = data.imageSrc;
		const breakAmount = data.breakAmount || 1000;
		const readMoreText = copy.$READ_MORE || 'Read More';
		const readLessText = copy.$READ_LESS || 'Read Less';
		if (body && body.length > breakAmount && !data.hideReadMore) {
			readMore = <Link class={this.s.readMore} extraOnClick={this.toggleFullBody} renderCustomChild>{this.state.fullBody ? readLessText : readMoreText}</Link>;

			if (!this.state.fullBody) {
				const shortBody = body.substr(0, breakAmount);
				body = shortBody.substr(0, Math.min(shortBody.length, shortBody.lastIndexOf(' '))) + '...';
			}
		}

		let readMoreCta = copy[data.readMoreCta] || data.readMoreCta || 'Read More';
		return (
			<Link class={thumbClass} href={data.readMoreLink || data.link} pageId={data.pageId ? data.pageId : false} target="_blank" trackId={data.trackId}>
				<div class={this.s.container} ref={$ref => this.$container = $ref}>
					{data.imageSrc && <img class={this.s.image} src={data.imageSrc} alt={data.imageAlt} />}
					<div class={this.s.textWrap}>
						{data.publication && <HTML tag="p" markdown class={this.s.publication}>{data.publication}</HTML>}
						{data.title && <HTML class={this.s.articleTitle} content={data.title} markdown tag="h2" />}
						{this.getExtraContent()}
						{data.subtitle && <HTML tag="h3" markdown class={this.s.articleSubtitle}>{data.subtitle}</HTML>}
						<p class={this.s.body}>
							{this.renderBodyImage()}
							{body && <HTML class={this.s.content} content={body} markdown />}
							{data.author && <HTML class={this.s.author} tag="p" markdown>{data.author}</HTML>}

						</p>
						{readMore}
						{data.readMoreLink && <Link href={data.readMoreLink} class={this.s.readMore} target="_blank" renderCustomChild>{readMoreCta}</Link>}
						{data.pathLink && <Link class={this.s.readMorePath} pageId={data.pathLink}>{readMoreCta}</Link>}
						<span class={this.s.date}>{data.date}</span>
						{this.getExtraContentBottom()}
					</div>
				</div>
			</Link>
		);
	}

}
